export default __webpack_public_path__ + "static/media/README.97cef303.md";